import { ButtonBase, ButtonBaseProps, styled, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react';

const StyledButtonBase = styled(ButtonBase)({
  textDecoration: 'underline',
  color: blue[500],
});

type Props = ButtonBaseProps & {
  text: string;
  to?: string;
};

const TypographyButton: React.FC<Props> = ({ text, ...props }) => {
  return (
    <Typography variant="inherit" display="inline">
      <StyledButtonBase {...props}>{text}</StyledButtonBase>
    </Typography>
  );
};

export default TypographyButton;
